import React from "react"
import {CmCollection, CmTeasable, SosTeaser} from "../../../../packages/graphql-layer/src";
import Carousel from 'react-material-ui-carousel'
import C014StageTeaser from "./C014StageTeaser";
import useWindowSize from "../../../utility/useWindowSize";

export interface Props {
    cmCollection?: CmCollection
    singleStageTeaser?: SosTeaser
}

// https://www.npmjs.com/package/react-material-ui-carousel
function C014StageCarousel(props: Props) {
    const {greaterThanWindowMedium} = useWindowSize()

    if (props.singleStageTeaser){
        return <C014StageTeaser item={props.singleStageTeaser}/>
    }
    else
    return <>
        {(props.cmCollection && props.cmCollection.items) || props.singleStageTeaser ?
            <Carousel autoPlay={false} navButtonsAlwaysVisible={props.cmCollection
                && props.cmCollection.items !== undefined && props.cmCollection.items!.length > 1}
                      navButtonsAlwaysInvisible={!greaterThanWindowMedium
                          || (props.cmCollection && props.cmCollection.items !== undefined
                              && props.cmCollection.items!.length === 1)
                          || (!props.cmCollection && props.singleStageTeaser !== undefined)}
                      indicators={false} animation={"slide"}
                      sx={{paddingTop: 0}}
            >

                {(props.cmCollection !== undefined ?
                    (props.cmCollection.items ?? []) : [props.singleStageTeaser])
                    .map(i => i as CmTeasable)
                    .filter(i => i.picture)
                    .map((item: any, index: number) =>
                      <C014StageTeaser key={index} item={item}/>

                    )
                }
            </Carousel>
            : null}

    </>
}

export default C014StageCarousel